import { Fragment, useRef, useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../../Context/AuthContext";
import { axiosInstance } from "../../axios/axiosInstance";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { ConvertToFloat, isValidArray } from "../../Layout/Common/common";
import { PriceTableContainerSkeleton } from "../../Skeleton/ProductListSkeleton";

export const PriceTableContainer = ({ productId, productCode, onHasPrices }) => {
  const [priceData, setPriceData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const { GetPriceTableData } = useGlobalFunction();
  const productData = useRef(null);

  useEffect(() => {
    const fetchPriceData = async (productId, productCode) => {
      const data = await GetPriceTableData(productId, productCode).catch(() => null);
      if (productData.current?.productId != productId) return;
      setPriceData(data);
      setLoaded(true);
      onHasPrices?.(isValidArray(data));
    };
    if (productData.current == null || productData.current.productId != productId) {
      productData.current = { productId, productCode };
      setPriceData(null);
      setLoaded(false);
      onHasPrices?.(true);
      fetchPriceData(productId, productCode);
    }
  }, [productId, productCode]);

  if (loaded && !isValidArray(priceData)) return null;

  return (
    <Fragment>
      <div className="proList-dropdown-info custom-table">
        <h5>Pricing Details</h5>
        <div className="pricingDetails-dropdown">
          <div className="pricingDetails-header d-lg-flex flex-lg-column">
            <div className="cost-ex order-lg-2">Cost Ex</div>
            <div className="cost-ex order-lg-3">Cost Inc</div>
            <div className="cost-ex order-lg-1">Qty</div>
          </div>
          <div className="pricingDetails-content">
            {isValidArray(priceData) ? (
              priceData.map((item, index) => (
                <div
                  className={`pricingDetails-content-list d-lg-flex flex-lg-column  ${item.actualQty == "your_price" ? " pricingDetails-content-listGreen" : ""}`}
                  key={index}
                >
                  <div className="price-ex order-lg-2">{ConvertToFloat(item.priceExc)}</div>
                  <div className="price-ex order-lg-3">{ConvertToFloat(item.priceInc)}</div>
                  <div className="price-ex order-lg-1">{item.qty}</div>
                </div>
              ))
            ) : (
              <PriceTableContainerSkeleton count={3} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
